import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { CafFormProvider } from "../contexts/CafFormContext";
import { DialogProvider } from "../contexts/DialogContext";
import { PlanProvider } from "../contexts/PlanContext";
import { PincodeProvider } from "../contexts/PincodeContext";
import { PlanGroupProvider } from "../contexts/PlanGroupContext";

export const CafFormComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <CafFormProvider key={0} />,
        <PlanProvider key={1} />,
        <PincodeProvider key={2} />,
        <PlanGroupProvider key={3} />,
        <DialogProvider key={4} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
